// extracted by mini-css-extract-plugin
export default {"CourseGridContainer":"CourseGridContainer_CourseGridContainer__zasJr"};